// utils/slugify.js
export function slugifyTR(str = "") {
  const trMap = { 'ç': 'c', 'ğ': 'g', 'ı': 'i', 'ö': 'o', 'ş': 's', 'ü': 'u', 'Ç': 'c', 'Ğ': 'g', 'İ': 'i', 'I': 'i', 'Ö': 'o', 'Ş': 's', 'Ü': 'u' };
  return String(str)
    .replace(/<[^>]+>/g, '')          // HTML etiketlerini temizle
    .normalize('NFD').replace(/[\u0300-\u036f]/g, "") // Birleşen karakterleri (nokta, aksan) kaldır
    .toLowerCase()
    .split('')
    .map(c => trMap[c] || c)
    .join('')
    .replace(/[^a-z0-9\u0600-\u06FF\u0400-\u04FF\u10A0-\u10FF]+/g, '-') // Sadece harf, rakam, Arapça, Kiril, Gürcüce ve tire bırak
    .replace(/-+/g, '-')              // Yan yana birden fazla tireyi teke indir
    .replace(/^-+|-+$/g, '')          // Baş ve sondaki tireleri temizle
    .trim();
}

export function buildAuthorPath({ name, surname, id }) {
  const slug = [slugifyTR(name), slugifyTR(surname)]
    .filter(Boolean).join("-");
  return `/author/${slug}-${id}`;
}

// URL’den id ayıklamak için:
export function extractIdFromSlug(slugParam = "") {
  const str = String(slugParam);
  const m = str.match(/-(\d+)$/);
  if (m) return m[1];
  const numMatches = str.match(/^(\d+)$/);
  return numMatches ? numMatches[1] : null;
}

// Yayıncı (publisher) için SEO path builder
export function buildPublisherPath({ title, id }) {
  const slug = slugifyTR(title || "");
  return `/publisher/${slug}-${id}`;
}

// Publication (article/book/etc) SEO path
export function buildPublicationPath({ title, id }) {
  const slug = slugifyTR(title || "");
  if (!slug) return `/publication/${id}`;
  return `/publication/${slug}-${id}`;
}

// Publication (article/book/etc) SEO path
export function buildPDFPath({ title, id }) {
  const slug = slugifyTR(title || "");
  if (!slug) return `/view/pdf/${id}`;
  return `/view/pdf/${slug}-${id}`;
}